/* =============================================================================
   ics-UI i18n - the EN base catalog: the strings the components emit, keyed
   `<area>.<name>`. Read through the localisation map (l10n/localisation-map.js) -
   a component calls t('messager.ok') and never carries a literal.
   It is the FALLBACK catalog for every other locale: a key missing from the
   active locale resolves to the English string here, never to a blank or to the
   raw key. So this file must carry EVERY key the components use - a new string
   is added here first, and a value changed here changes what every screen shows
   in every locale that does not translate that key.
   ============================================================================= */
export default {
  'combo.selectOne': '--Select One--',
  'data.notFound': 'Data Not Found.',
  'progress.pleaseWait': 'Processing...',          // the KEY is the stable id components call; the VALUE is the positive phrase the product shows
  'messager.ok': 'Ok',
  'messager.cancel': 'Cancel',
  'messager.alertTitle': 'Alert',
  'messager.confirmTitle': 'Confirm',
  'picker.search': 'Search',
  'validation.required': 'This field is required.',
};
